import { getRedNoteDetail } from '@/api';
import { urlFormatToJump } from '../../service/router';
import { jumpToApp } from '../../utils/tools';
export default {
  name: 'RednotePage',
  data() {
    return {
      // 活动ID参数
      activity_id: this.$route.query.activity_id,
      // 数据模型
      prizeModel: {
        activity_info: {
          activity_id: '',
          status: 0,
          // 0进行中 1开奖中 2开奖成功 3不开奖
          title: '',
          join_number: 0,
          prize_type: 1,
          // 1奖品 2购买权 3审核
          describe: '',
          draw_rule: '',
          on_time_distribute_txt: '',
          end_time: '',
          rednote_link: '',
          share_code: ''
        },
        item_info: {
          item_id: '',
          item_type: 1,
          item_type_name: '众筹',
          title: '',
          jump_url: ''
        },
        prize_list: []
      },
      selectedPrizeIndex: 0,
      loading: false,
      error: ''
    };
  },
  mounted() {
    this.getRedNotePrizeDetail();
  },
  methods: {
    getStatusText() {
      switch (this.prizeModel.activity_info.status) {
        case 1:
          return '活动已结束，开奖中~';
        case 2:
          return '活动已开奖，查看中奖名单';
        case 3:
          return '活动不开奖';
        default:
          return '';
      }
    },
    // 方法
    selectPrize(index) {
      this.selectedPrizeIndex = index;
    },
    getCurrentPrize() {
      // 获取当前选中的奖品，如果没有奖品则返回默认对象
      if (this.prizeModel.prize_list && this.prizeModel.prize_list.length > 0) {
        return this.prizeModel.prize_list[this.selectedPrizeIndex] || this.prizeModel.prize_list[0];
      }
      return {
        img: '',
        prize_name: '暂无奖品',
        num: 0,
        relation_type: 1,
        price: '',
        jump_url: ''
      };
    },
    getTotalPrizeCount() {
      // 计算所有奖品的总数量
      if (this.prizeModel.prize_list && this.prizeModel.prize_list.length > 0) {
        return this.prizeModel.prize_list.reduce((total, prize) => total + (prize.num || 0), 0);
      }
      return 0;
    },
    handlePrizeResult() {
      if (this.prizeModel.activity_info.status === 2) {
        this.guideToApp();
      }
    },
    handlePrizeClick() {
      this.guideToApp();
    },
    //项目点击
    handleProjectClick() {
      if (this.prizeModel.item_info.jump_url) {
        urlFormatToJump(this.prizeModel.item_info.jump_url);
      }
    },
    handleRedNoteShare() {
      this.guideToApp();
    },
    handleUploadLink() {
      this.guideToApp();
    },
    async guideToApp() {
      try {
        await jumpToApp({
          type: 'xhsPrizeDetail',
          id: this.activity_id
        });
      } catch (error) {
        // jumpToApp 内部已经处理了错误提示
        console.error('跳转APP失败:', error);
      }
    },
    // API接口 - 获取小红书活动详情
    async getRedNotePrizeDetail() {
      if (!this.activity_id) {
        this.error = '缺少活动ID参数';
        return;
      }
      try {
        this.loading = true;
        this.error = '';
        const response = await getRedNoteDetail({
          activity_id: this.activity_id
        });
        if (response && response.status === 0) {
          // 解析数据模型
          // 直接使用response.data赋值给prizeModel

          this.prizeModel = response.data;
          this.prizeModel.prize_list = response.data.prize_list || [];
        } else {
          this.error = (response === null || response === void 0 ? void 0 : response.message) || '获取活动详情失败';
          console.error('API Error:', response);
        }
      } catch (err) {
        this.error = '网络请求失败，请稍后重试';
        console.error('Request Error:', err);
      } finally {
        this.loading = false;
      }
    }
  }
};